import api from '@/common/api';
import axios from 'axios';
import { getToken } from '@/common/jwt.service';
import { cloneDeep } from 'lodash';
/* eslint-disable */

const initialState = () => ({
  loading: {
    load: false,
    create: false,
    edit: false,
    delete: false,
  },
  errors: {
    load: [],
    create: [],
    delete: [],
    edit: [],
  },
  count: 0,
  items: [],
  selected: [],
  filter: {
    pageSize: 20,
    page: 1,
    name: '',
    upload_date_from: null,
    upload_date_to: null,
    type: '',
    source: '',
    comment: '',
  },
  candidateId: 0,
});

export default {
  namespaced: true,
  state: cloneDeep(initialState()),
  actions: {
    async loadItems({ commit, getters, state }, candidateId) {
      commit('loadItemsRequest');

      if (candidateId) {
        commit('setCandidateId', candidateId);
      } else {
        candidateId = state.candidateId
      }

      try {
        const filter = {};
        Object.keys(getters.filter).forEach((key) => {
          if (key === 'page') return;
          if (Array.isArray(getters.filter[key])) {
            if (getters.filter[key].length) {
              filter[key] = getters.filter[key];
            }
            return;
          }
          if (getters.filter[key]) {
            if (key==='type' || key==='source')
              filter[key] = getters.filter[key].split(',') ;
            else
              filter[key] = getters.filter[key];
          }
        });

        const response = await api.post(
          `/users/candidates/${candidateId}/dossier/filter/?page=${getters.filter.page}&page_size=${getters.filter.pageSize}`,
          filter,
        );
        commit('setItems', response.results);
        commit('setCount', response.count);
        commit('loadItemsSuccess');
      } catch (err) {
        commit('loadItemsFailure', Object.entries(err.data));
        throw err;
      }
    },
    async addDocument({ commit, dispatch, getters, state }, payload) {
      commit('addDocumentRequest');
      try {
        const response = await api.post(`/users/candidates/${state.candidateId}/dossier/`, payload);
        commit('addDocumentSuccess');
        if (getters.filter.page === 1) {
          dispatch('loadItems');
        }
        return response
      } catch (err) {
        commit('addDocumentFailure', Object.entries(err.data));
        throw err;
      }
    },
    async delDocument({ commit, dispatch, getters, state }, id) {
      commit('delDocumentRequest', id);
      try {
        const response = await api.delete(`/users/candidates/${state.candidateId}/dossier/${id}/`);
        commit('delDocumentSuccess');
        if (getters.filter.page === 1) {
          dispatch('loadItems');
        }
        return response
      } catch (err) {
        commit('delDocumentFailure', Object.entries(err.data));
        throw err;
      }
    },
    async editDossierComment({ state, commit }, { id, text }) {
      // commit('editCandidateCommentRequest', id);
      try {
        const response = await api.patch(`/users/candidates/${state.candidateId}/dossier/${id}/`, { comment: text });
        // commit('editCandidateCommentSuccess', response);
      } catch (err) {
        // commit('editCandidateCommentFailure', { id, error: Object.entries(err.data) });
        throw err;
      }
    },

    async downloadDocument({ state, commit }, documentId) {
      try {
        const response = await axios.get(`/users/candidates/${state.candidateId}/dossier/${documentId}/download/`, {
          baseURL: api.defaults.baseURL,
          headers: {
            Authorization: `Token ${getToken()}`
          },
          responseType: 'blob'
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = '';
        if (contentDisposition) {
            // Сначала ищем filename* с кодировкой UTF-8
          const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
          if (utf8FilenameMatch && utf8FilenameMatch[1]) {
            try {
              filename = decodeURIComponent(utf8FilenameMatch[1]);
            } catch (e) {
              console.error('Ошибка при декодировании filename*:', e);
            }
          }
          if (!filename) {
            // Если filename* не найден или произошла ошибка, ищем обычный filename
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/^"|"$/g, '');
            }
          }
          if (!filename)
            filename = 'downloaded-file';

          // const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          // if (filenameMatch.length > 1) {
          //   filename = filenameMatch[1];
          // }
        } else {
          console.log("Нет заголовка content-disposition. Нужно в NGINX добавить настрйоку add_header 'Access-Control-Expose-Headers' 'Content-Disposition' always;")
          return false
        }
        filename = filename.replace(/^"+|"+$/g, '');
        const blob = new Blob([response.data]);

        return { filename, blob }
      } catch (error) {
        console.error('Download failed:', error);
      }
    },

    async setFilterPage({ commit, dispatch }, page) {
      commit('setFilterPage', page);
      await dispatch('loadItems');
    },
    async setFilterPageSize({ commit, dispatch }, payload) {
      commit('setFilterPage', payload.page);
      commit('setFilterPageSize', payload.pageSize);
      await dispatch('loadItems');
    },
    async setFilterName({ commit, dispatch }, name) {
      commit('setFilterName', name);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterUploadDate({ commit, dispatch }, dates) {
      commit('setFilterUploadDate', dates);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterType({ commit, dispatch }, type) {
      commit('setFilterType', type);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterSource({ commit, dispatch }, source) {
      commit('setFilterSource', source);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterComment({ commit, dispatch }, comment) {
      commit('setFilterComment', comment);
      commit('setFilterPage', 1);
      await dispatch('loadItems');
    },
    async setFilterAll({ commit, dispatch }, { candidateId, params }) {
      commit('setFilterPage', parseInt(params.page, 10) || 1);
      commit('setFilterName', params.name ?? '');
      commit('setFilterType', params.type ?? '');
      commit('setFilterSource', params.source ?? '');
      commit('setFilterComment', params.comment ?? '');
      await dispatch('loadItems', candidateId);
    },
    async clearFilterAll({ commit, dispatch }) {
      commit('setFilterName', '');
      commit('setFilterType', '');
      commit('setFilterSource', '');
      commit('setFilterComment', '');
      commit('setFilterUploadDate', [null, null]);
      await dispatch('loadItems');
    },

    clearError({ commit }) {
      commit('clearError');
    },
    setSelected({ commit }, id) {
      commit('setSelected', id);
    },
    allSelected({ commit }) {
      commit('allSelected');
    },
    clearSelected({ commit }) {
      commit('clearSelected');
    },

    // async deleteCandidates({ getters, commit, dispatch }, candidates) {
    //   if (!(getters.selected.length || candidates.length)) return;
    //   commit('deleteCandidatesRequest');
    //   try {
    //     const data = {
    //       candidates: getters.selected,
    //     };
    //     if (candidates) {
    //       data.candidates = candidates;
    //     }
    //     await api.delete('/users/candidates/bulk-delete/', { data });
    //     commit('clearSelected');
    //     dispatch('loadItems');
    //     commit('deleteCandidatesSuccess');
    //   } catch (err) {
    //     commit('deleteCandidatesFailure', Object.entries(err.data));
    //     throw err;
    //   }
    // },

  },
  mutations: {
    clearError(state) {
      state.errors = initialState().errors;
    },
    setCount(state, count) {
      state.count = count;
    },
    setItems(state, items) {
      state.items = items
    },
    setCandidateId(state, candidateId) {
      state.candidateId = candidateId
    },
    setFilterPage(state, page) {
      state.filter.page = parseInt(page, 10);
    },
    setFilterPageSize(state, pageSize) {
      state.filter.pageSize = parseInt(pageSize, 10);
    },
    setFilterName(state, name) {
      state.filter.name = name;
    },
    setFilterUploadDate(state, dates) {
      // eslint-disable-next-line prefer-destructuring
      state.filter.upload_date_from = dates[0];
      // eslint-disable-next-line prefer-destructuring
      state.filter.upload_date_to = dates[1];
    },
    setFilterType(state, type) {
      state.filter.type = type;
    },
    setFilterSource(state, source) {
      state.filter.source = source
    },
    setFilterComment(state, comment) {
      state.filter.comment = comment;
    },
    setSelected(state, id) {
      if (id || id === 0) {
        const itemFound = state.selected.some((item) => item === id);
        if (itemFound) {
          state.selected = state.selected.filter((item) => item !== id);
        } else {
          state.selected.push(id);
        }
      } else {
        state.selected = [];
      }
    },
    allSelected(state) {
      state.candidates.forEach((c) => {
        if (!state.selected.some((id) => c.id === id)) {
          state.selected.push(c.id);
        }
      });
    },
    clearSelected(state) {
      state.selected = [];
    },

    loadItemsRequest(state) {
      state.loading.load = true;
      state.errors.load = [];
    },
    loadItemsSuccess(state) {
      state.loading.load = false;
    },
    loadItemsFailure(state, error) {
      state.errors.load = error;
      state.loading.load = false;
    },

    addDocumentRequest(state) {
      state.loading.create = true;
      state.errors.create = [];
    },
    addDocumentSuccess(state) {
      state.loading.create = false;
    },
    addDocumentFailure(state, error) {
      state.errors.create = error;
      state.loading.create = false;
    },

    delDocumentRequest(state, id) {
      state.loading.del = id;
      state.errors.del = [];
    },
    delDocumentSuccess(state) {
      state.loading.del = false;
    },
    delDocumentFailure(state, error) {
      state.errors.del = error;
      state.loading.del = false;
    },

    editCandidateRequest(state) {
      state.loading.edit = true;
      state.errors.edit = [];
    },
    editCandidateSuccess(state) {
      state.loading.edit = false;
    },
    editCandidateFailure(state, error) {
      state.errors.edit = error;
      state.loading.edit = false;
    },

    deleteCandidatesRequest(state) {
      state.loading.delete = true;
      state.errors.delete = [];
    },
    deleteCandidatesSuccess(state) {
      state.loading.delete = false;
    },
    deleteCandidatesFailure(state, error) {
      state.errors.delete = error;
      state.loading.delete = false;
    },

    activeCandidatesRequest(state) {
      state.loading.active = true;
      state.errors.active = [];
    },
    activeCandidatesSuccess(state) {
      state.loading.active = false;
    },
    activeCandidatesFailure(state, error) {
      state.errors.active = error;
      state.loading.active = false;
    },

    reset(state) {
      Object.assign(state, cloneDeep(initialState()));
    }
  },
  getters: {
    candidateId: (state) => state.candidateId,
    loading: (state) => state.loading,
    errors: (state) => state.errors,
    count: (state) => state.count,
    filter: (state) => state.filter,
    items: (state) => state.items,
    selected: (state) => state.selected,
    isFilterEmpty: (state) => !state.filter.name && !state.filter.type && !state.filter.source
      && !state.filter.from_date_joined && !state.filter.to_date_joined && !state.filter.comment,
  },
};
